import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Nav from '../Nav/Nav';
import './OnePlusStore.css';
import Footer from '../Footer/Footer';
import OnePlusProductList from './OnePlusProductList';
import onePlusNordCE5 from '../../assets/OnePlus/OnePlusNordCE/OnePlusNordCE5.png';
import onePlus15s from '../../assets/OnePlus/OnePlus15S/OnePlus15s.png';
import onePlus15 from '../../assets/OnePlus/OnePlus15/OnePlus15.png';
import onePlusPadGo2 from '../../assets/OnePlus/OnePlusPad/PadGo2/Go2.png';

export const onePlusProducts = [
  {
    id: 1,
    model: 'OnePlus Nord',
    type: 'phone',
    title: 'OnePlus Nord',
    description: 'Premium Mid-Range Performance',
    image: onePlusNordCE5,
  },
  {
    id: 2,
    model: 'OnePlus 15S',
    type: 'phone',
    title: 'OnePlus 15S',
    description: 'Compact Flagship Power',
    image: onePlus15s,
  },
  {
    id: 3,
    model: 'OnePlus 15',
    type: 'phone',
    title: 'OnePlus 15',
    description: 'Ultimate Flagship Experience',
    image: onePlus15,
  },
  {
    id: 4,
    model: 'OnePlus Pad',
    type: 'tablet',
    title: 'OnePlus Pad',
    description: 'Immersive Display. All-day Power.',
    image: onePlusPadGo2,
  },
];

const OnePlusStore = () => {
  const navigate = useNavigate();
  const onePlusData = useSelector((state) => state.products.onePlusData);

  const parsePrice = (value) =>
    Number(String(value ?? '').replace(/[^\d]/g, '')) || 0;

  const flagshipProducts = onePlusData.filter((product) => {
    const title = product.title.toLowerCase();
    return !title.includes('nord') && !title.includes('pad');
  });
  const onePlusPadProducts = onePlusData.filter((product) =>
    product.title.toLowerCase().includes('oneplus pad')
  );
  const onePlusNordProducts = onePlusData.filter((product) =>
    product.title.toLowerCase().includes('nord')
  );

  const mostExpensiveFlagship = flagshipProducts.reduce((highest, current) => {
    if (!highest) {
      return current;
    }

    return parsePrice(current.discountedPrice) > parsePrice(highest.discountedPrice)
      ? current
      : highest;
  }, null);
  const featuredPadProduct = onePlusPadProducts.reduce((highest, current) => {
    if (!highest) {
      return current;
    }

    return parsePrice(current.discountedPrice) > parsePrice(highest.discountedPrice)
      ? current
      : highest;
  }, null);
  const featuredNordProduct = onePlusNordProducts.reduce((highest, current) => {
    if (!highest) {
      return current;
    }

    return parsePrice(current.discountedPrice) > parsePrice(highest.discountedPrice)
      ? current
      : highest;
  }, null);

  const getSpecHighlights = (product) => {
    if (!product?.specifications) {
      return {};
    }

    const pick = (keys) => {
      for (const key of keys) {
        const section = product.specifications[key];
        if (Array.isArray(section) && section.length > 0) {
          return section[0];
        }
      }
      return null;
    };

    return {
      battery: pick(['Battery']),
      camera: pick(['Camera']),
      software: pick(['Software', 'Performance']),
    };
  };

  const flagshipHighlights = getSpecHighlights(mostExpensiveFlagship);
  const nordHighlights = getSpecHighlights(featuredNordProduct);
  const padHighlights = getSpecHighlights(featuredPadProduct);

  const handleExploreFlagship = () => {
    if (mostExpensiveFlagship) {
      navigate(`/oneplusstore/products-list/product-detail/oneplus/${mostExpensiveFlagship.id}`);
    }
  };
  const handleLearnMoreFlagship = () => {
    if (mostExpensiveFlagship) {
      navigate(`/oneplusstore/products-list/product-detail/oneplus/${mostExpensiveFlagship.id}`);
    }
  };
  const handleShopFlagship = () => {
    navigate('/oneplusstore/products-list/oneplus?series=flagship');
  };
  const handleExplorePad = () => {
    navigate('/oneplusstore/products-list/oneplus?series=pad');
  };
  const handleExploreNord = () => {
    navigate('/oneplusstore/products-list/oneplus?series=nord');
  };

  return (
    <>
      <Nav theme="light" />
      <div className="oneplus-store-wrapper">
        <section className="oneplus-store">
          <OnePlusProductList />
        </section>

        <section className="oneplus-banner-section">
          <div className="oneplus-banner">
            <div className="oneplus-banner-content">
              <h1 className="oneplus-banner-title">Never Settle</h1>
              <p className="oneplus-banner-subtitle">
                {mostExpensiveFlagship
                  ? `Experience flagship performance with ${mostExpensiveFlagship.title}`
                  : 'Experience flagship performance'}
              </p>
              <div className="oneplus-banner-buttons">
                <button className="banner-button" onClick={handleLearnMoreFlagship}>
                  Learn More
                </button>
                <button className="banner-button banner-button-outline" onClick={handleShopFlagship}>
                  Shop Now
                </button>
              </div>
            </div>
          </div>
        </section>

        <section className="oneplus-features">
          <div className="feature-card">
            <h3>Battery & Charging</h3>
            <p>
              {flagshipHighlights.battery ||
                'All-day battery life with fast charging support'}
            </p>
          </div>
          <div className="feature-card">
            <h3>Camera</h3>
            <p>
              {nordHighlights.camera ||
                flagshipHighlights.camera ||
                'Flagship-grade camera experience'}
            </p>
          </div>
          <div className="feature-card">
            <h3>Software & Performance</h3>
            <p>
              {padHighlights.software ||
                flagshipHighlights.software ||
                'Smooth and optimized OnePlus experience'}
            </p>
          </div>
        </section>

        <section className="oneplus-showcase">
          <div className="showcase-grid">
            <div
              className="showcase-item showcase-large"
              style={
                mostExpensiveFlagship?.productImage
                  ? {
                      backgroundImage: `linear-gradient(135deg, rgba(10, 10, 10, 0.82), rgba(26, 26, 26, 0.6)), url(${mostExpensiveFlagship.productImage})`,
                      backgroundSize: 'cover, contain',
                      backgroundPosition: 'center, right center',
                      backgroundRepeat: 'no-repeat, no-repeat',
                    }
                  : undefined
              }
            >
              <div className="showcase-content">
                <h2>{mostExpensiveFlagship?.title || 'OnePlus Flagship'}</h2>
                <p>The ultimate flagship experience</p>
                <button
                  className="showcase-btn"
                  onClick={handleExploreFlagship}
                  disabled={!mostExpensiveFlagship}
                >
                  Explore
                </button>
              </div>
            </div>
            <div
              className="showcase-item showcase-pad"
              onClick={handleExplorePad}
              style={
                featuredPadProduct?.productImage
                  ? {
                      backgroundImage: `url(${featuredPadProduct.productImage})`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'right center',
                      backgroundRepeat: 'no-repeat',
                    }
                  : undefined
              }
            >
              <div className="showcase-content">
                <h3>OnePlus Pad</h3>
                <p>Work meets entertainment</p>
              </div>
            </div>
            <div
              className="showcase-item showcase-nord"
              onClick={handleExploreNord}
              style={
                featuredNordProduct?.productImage
                  ? {
                      backgroundImage: `url(${featuredNordProduct.productImage})`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'right center',
                      backgroundRepeat: 'no-repeat',
                    }
                  : undefined
              }
            >
              <div className="showcase-content">
                <h3>OnePlus Nord</h3>
                <p>Premium Mid-Range Performance</p>
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default OnePlusStore;
